import React, { ForwardedRef } from 'react';
import { ButtonProps } from 'react-bootstrap'
import cn from 'classnames'
import type { ButtonVariant } from 'react-bootstrap/esm/types'
type CustomSize = 'sm' | 'md' | 'lg'

type Props = Omit<ButtonProps, 'size'> & {
	hover?: {
		scale?: boolean
	}
	children?: React.ReactNode
	size?: CustomSize
	className?: string
	variant?: ButtonVariant
	width?: 'full' | number | ''
	height?: 'full' | number | '' | 'auto'
	style?: React.CSSProperties
	fontFamily?: 'libre' | 'rubik' | 'mazius'
	fontSize?: 'sm' | 'md'
	fw?: 'bold' | 'normal'
	px?: number
	ref?: React.RefObject<HTMLButtonElement>
}

const Button = React.forwardRef<HTMLButtonElement, Props>(({
	type = 'button',
	hover = {scale: false},
	className = '',
	children,
	size = 'md', 
	variant = 'primary', 
	fontFamily = 'libre', 
	fontSize = 'sm',
	width = '', 
	height = '',
	px,
	fw = 'bold',
	...props}, ref) => {
	const defaultClass = `btn btn-${variant} d-flex align-items-center justify-content-center gap-2 fw-${fw}`
	let customClasses = `font-${fontFamily} font-size-${fontSize}`
	const customStyles: React.CSSProperties = {...props.style}

	if (hover.scale) {
		customClasses += ' hover-scale'
	}

	if (width !== 'full') {
		customStyles.width = width
	}
	if (height !== 'full') {
		customStyles.height = height
	}

	if (px) {
		customStyles.paddingLeft = px
		customStyles.paddingRight = px
	}

  return (
	<button type={type} {...props} className={cn(defaultClass, {
		[size]: height === '',
		'w-100': width === 'full',
		'h-100': height === 'full',
	}, customClasses, className)} style={customStyles} ref={ref}>{children}</button>
  )
})

export default Button
